import React from 'react';
import ourbenefit from '../assets/images/our-benefit-img.jpg';

const Signin = () => {
  const containerStyle = {
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 5%',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#00424f', // Dark teal/blue background from image
  };

  const leftStyle = {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const logoStyle = {
    width: '300px',
    marginBottom: '30px',
  };

  const illustrationStyle = {
    width: '350px',
    marginTop: '20px',
  };

  const rightStyle = {
    width: '40%',
    padding: '40px',
    borderRadius: '15px',
    backgroundColor: '#ffffff', // White background for the form
    boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
    border: '1px solid #ccc',
  };

  const headingStyle = {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#00424f', // Matching the brand blue/teal
    marginBottom: '30px',
  };

  const inputLabelStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '5px',
    color: '#00424f', // Match label to brand color
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 15px',
    marginBottom: '20px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    outline: 'none',
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    backgroundColor: '#00c853', // Bright green
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    cursor: 'pointer',
  };

  return (
    <div style={containerStyle}>
      {/* Left Side */}
      <div style={leftStyle}>
        {/* <img src="/logo.png" alt="Logo" style={logoStyle} /> */}
        <img src={ourbenefit} alt="Illustration" style={illustrationStyle} />
      </div>

      {/* Right Side */}
      <div style={rightStyle}>
        <h2 style={headingStyle}>Log In</h2>
        <label style={inputLabelStyle}>Username</label>
        <input type="text" placeholder="Username" style={inputStyle} />

        <label style={inputLabelStyle}>Password</label>
        <input type="password" placeholder="Password" style={inputStyle} />

        <button style={buttonStyle}>Send OTP</button>
      </div>
    </div>
  );
};

export default Signin;
